"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingTarget = void 0;
var RatingTarget;
(function (RatingTarget) {
    RatingTarget["Agent"] = "agent";
    RatingTarget["Ai"] = "ai";
})(RatingTarget = exports.RatingTarget || (exports.RatingTarget = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsSUFBWSxZQUdYO0FBSEQsV0FBWSxZQUFZO0lBQ3ZCLCtCQUFlLENBQUE7SUFDZix5QkFBUyxDQUFBO0FBQ1YsQ0FBQyxFQUhXLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBR3ZCIn0=